webpackJsonp([253713313292291],{

/***/ 1809:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ImmunizationEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"Immunization","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-immunization-edge-d9a4e8c752778ad60f89.js